import { DrawerFilterType } from '../../../models';

export const documentsFilters = [
  {
    label: 'Type',
    name: 'type',
    type: DrawerFilterType.SELECT,
    value: undefined,
    list: [],
  },
  {
    label: 'Creator',
    name: 'creatorId',
    type: DrawerFilterType.SELECT,
    value: undefined,
    list: [],
  },
  {
    label: 'Who Can View?',
    name: 'startDate',
    type: DrawerFilterType.SELECT,
    value: undefined,
    list: [],
  },
  {
    label: 'Tags',
    name: 'tags',
    type: DrawerFilterType.SELECT,
    value: undefined,
    list: [],
  },
];
